import React from "react";

type TriggerType = "email" | "recurrence" | "http";

type Props = {
  triggerType: TriggerType;
  setTriggerType: React.Dispatch<React.SetStateAction<TriggerType>>;
  openPayloadEditor: () => void;
};

export default function TriggerInspector({
  triggerType,
  setTriggerType,
  openPayloadEditor,
}: Props) {
  return (
    <>
      <div className="rounded-xl border border-orange-200 bg-orange-50 p-4 dark:border-orange-500/20 dark:bg-orange-500/10">
        <div className="text-sm font-semibold text-slate-950 dark:text-white">
          Workflow trigger
        </div>

        <p className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-400">
          De trigger is altijd de eerste stap van de workflow. Kies hier hoe de flow gestart wordt.
        </p>
      </div>

      <div className="rounded-xl border border-slate-200 bg-slate-50/80 p-4 dark:border-white/10 dark:bg-slate-950/60">
        <label className="text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-400">
          Trigger type
        </label>

        <div className="mt-3 grid grid-cols-3 gap-2">
          {[
            { value: "http", label: "HTTP" },
            { value: "email", label: "Email" },
            { value: "recurrence", label: "Schema" },
          ].map((item) => (
            <button
              key={item.value}
              type="button"
              onClick={() => setTriggerType(item.value as TriggerType)}
              className={`rounded-xl px-3 py-2 text-xs font-black transition ${
                triggerType === item.value
                  ? "bg-orange-500 text-white"
                  : "bg-white text-slate-600 hover:bg-slate-100 dark:bg-white/10 dark:text-slate-300 dark:hover:bg-white/15"
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>
      </div>

      {triggerType === "http" && (
        <button
          type="button"
          onClick={openPayloadEditor}
          className="w-full rounded-xl bg-orange-500 px-5 py-3 text-sm font-black text-white shadow-lg shadow-orange-500/10 transition hover:-translate-y-[1px] hover:bg-orange-400"
        >
          Payload invoeren
        </button>
      )}
    </>
  );
}